﻿import State from './State.js';
import ScoreCalculator from './ScoreCalculator.js';
export default class StateShowCrib extends State {
    constructor(context) {
        super(context);
        this.name = 'showCrib';
        this.calc = new ScoreCalculator();
    }
    setup() {

        this.scoreDealersCrib();
        
    }
    action(command, value, player) {
        switch (command) {
            case "nextShow": return this.next(player); break;
            case "next": return this.next(player); break;
            // case "nextRound": this.endRound(player); break;
            default: return this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        actions.push({ command: "nextShow", value: null });
        actions.push({ command: "next", value: null });
        //actions.push({ command: "nextRound", value: null });
        return actions;
    }
    next() {
        this.context.setState("endRound");
        return true;
    }
 
    scoreDealersCrib() {
        let dealer = this.context.dealer;
        
        //let dealerHandName = dealer == "player1" ? "handShow1" : "handShow2";

        let cribPileName = dealer == "player1" ? "cribShow1" : "cribShow2";
        

        //message
        this.context.messagePlayer1 = "";
        this.context.messagePlayer2 = "";
 
        if(dealer === "player1")this.context.messagePlayer1 = "Crib";
        if(dealer === "player2")this.context.messagePlayer2 = "Crib";

 
        // //clear all cards in hands
        // let hand1Cards = this.context.getPile("hand1");
        // for (let i = 0; i < hand1Cards.length; i++) {
        //     let card = hand1Cards[i];
        //     card.showfront = true;
        //     this.context.addToPile(card, "deck", "system");
        // }
        // let hand2Cards = this.context.getPile("hand2");
        // for (let i = 0; i < hand2Cards.length; i++) {
        //     let card = hand2Cards[i];
        //     card.showfront = true;
        //     this.context.addToPile(card, "deck", "system");
        // }


        // //note: do i need to do this? this is UI related only
        // //clear all  dealers card
        // let dealerHand = this.context.getPile(dealerHandName);
        // for (let i = 0; i < dealerHand.length; i++) {
        //     let card = dealerHand[i];
        //     card.showfront = true;
        //     this.context.addToPile(card, "played", "system");
        // }



        //pull cards from cirb pile and place back in hand to score
        //let cribCards = this.context.getPile(cribPileName);
        let cribCards = this.context.getCardsByOwner("crib");
        for (let i = 0; i < cribCards.length; i++) {
            let card = cribCards[i];
            card.showfront = false;
            this.context.addToPile(card, cribPileName, "system");
        }
        this.context.sortPile(cribPileName);


        let starterCard = this.context.getStarterCard();

        //and then turns the cards in the crib face up
        let pointsCard = this.calc.scoreCrib(starterCard, cribCards, dealer);
        this.context.awardPointsArray(pointsCard);

        //get total points for array
        let totalPoints = pointsCard.reduce(function (total, pointLog) {
            return total + pointLog["points"];
        }, 0);

        //send totalPoints as message for UI to show
        this.context.sendEvent("handPoints", totalPoints + " Crib", dealer);

        this.context.sendEvent("message", "Crib", dealer);
        this.step = "scoreCrib";
    }

    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}